export default __webpack_public_path__ + "static/media/feintattack7.ad42a930.png";